<header class="flex h-12 max-xl:h-14 items-center justify-between border-b border-white/15 bg-[#2e5ea8] px-4 max-xl:ps-16 text-white shadow-sm">
  <!-- Left: Breadcrumbs -->
  <nav data-slot="breadcrumb" role="navigation" aria-label="breadcrumb" class="flex items-center">
    <ol class="m-0 p-0 list-none flex flex-wrap items-center gap-1.5 text-sm text-white/80 sm:gap-2.5">
      <li class="inline-flex items-center gap-1.5">
        <a routerLink="/uco/dashboard" class="flex items-center gap-2 text-white/80 hover:text-white transition-colors">
          <lucide-icon [img]="icons.home" [size]="16" aria-hidden="true" />
          <span class="max-md:hidden font-medium">Home</span>
        </a>
      </li>
      @if (sectionTitle) {
        <li role="presentation" aria-hidden="true" class="flex items-center text-white/60">
          <lucide-icon [img]="icons.chevron" [size]="14" aria-hidden="true" />
        </li>
        <li class="inline-flex items-center gap-1.5">
          <span class="text-white/80 hover:text-white transition-colors max-md:hidden">{{ sectionTitle }}</span>
          <span class="flex items-center md:hidden text-white/80">
            <lucide-icon [img]="icons.ellipsis" [size]="16" aria-hidden="true" />
            <span class="sr-only">{{ sectionTitle }}</span>
          </span>
        </li>
      }
      <li role="presentation" aria-hidden="true" class="flex items-center text-white/60">
        <lucide-icon [img]="icons.chevron" [size]="14" aria-hidden="true" />
      </li>
      <li class="inline-flex items-center gap-1.5">
        <span aria-current="page" class="font-medium text-white">{{ pageTitle }}</span>
      </li>
    </ol>
  </nav>

  <!-- Right: Notifications & User Account -->
  <div class="flex items-center gap-2">
    <app-notification-dropdown (opening)="account?.close()" />
    <app-user-account-menu [header]="true" (opening)="notifications?.closeDropdown()" />
  </div>
</header>
